import { StoreAndMarker } from "src/app/pages/locations/locations.models";
import Stripe from "stripe";
import {
  Account,
  AccountCheckResponse,
  AccountInfoResponse,
  AccountQuota,
  CancelReason,
  CustomerPaymentMethod,
  GetProfileResponse,
  Order,
  OrderHeader,
  OrderItem,
  OrderTypesEnum,
  PromoDetails,
  QsysProfile,
  Store,
  RegionMenu,
  StripeStatusEnum,
  SubscriptionDetail,
  SubscriptionItemTypeEnum,
  SwapReason,
  Vehicle,
  VehicleSwapResponse,
  GrandOpening,
} from "./myqq.models";
export const MockGoodWashLevelName = "good";
export const MockBetterWashLevelName = "better";
export const MockBestWashLevelName = "best";
export const MockCeramicWashLevelName = "ceramic";

export const MockPlansPromoSvg = `<svg width="380" height="84" viewBox="0 0 380 84" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<rect width="380" height="84" fill="url(#pattern0)"/>
<defs>
<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1_16" transform="scale(0.00263158 0.0119048)"/>
</pattern>
<image id="image0_1_16" width="380" height="84" xlink:href="data:image/png;base64,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"/>
</defs>
</svg>
`;

export const MOCK_STORE: Store = {
  storeId: "MOCK_STORE_ID",
  regionId: "MOCK_REGION_ID",
  regionNumber: "0",
  storeNumber: "0",
  name: "West Sacramento",
  addressLine1: "111 West Sac Drive",
  city: "West Sacramento",
  state: "CA",
  zipCode: "95616",
  phoneNumber: "5308675309",
  defaultLaneNumber: 1,
  timeZone: "PST",
  connectAccountId: "MOCK_CONNECT_ACCOUNT_ID",
};

export const MOCK_STOREANDMARKER: StoreAndMarker = [
  {
    storeId: "MOCK_STORE_ID",
    regionId: "MOCK_REGION_ID",
    regionNumber: "0",
    storeNumber: "0",
    name: "West Sacramento",
    addressLine1: "111 West Sac Drive",
    city: "West Sacramento",
    state: "CA",
    zipCode: "95616",
    phoneNumber: "5308675309",
    defaultLaneNumber: 1,
    timeZone: "PST",
    connectAccountId: "MOCK_CONNECT_ACCOUNT_ID",
  },
  null,
];

export const MOCK_VEHICLES: Vehicle[] = [
  {
    vehicleId: "f43bf551-a149-4dc0-9790-ab58758f5317",
    personId: "d92c06bf-af49-48c3-9550-cfc5c7aceabd",
    license: "YMENT",
    state: "PA",
    createdBy: "29421a23-1403-404e-8669-f6b53c55563f",
    createdIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    createdAt: "2020-06-23T20:17:15.381719Z",
    updatedBy: "29421a23-1403-404e-8669-f6b53c55563f",
    updatedIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    updatedAt: "2020-06-23T20:17:15.431017Z",
    make: "FORD",
    model: "RANGER",
    year: "2020",
    vin: "WP0AB2A86EK190719",
    hasMembership: true,
    expiring: false,
    isVerified: true,
    isTemporaryIdentifier: true,
    verificationCode: "",
  },
  {
    vehicleId: "92a7c406-7ded-4fee-8b69-0c8ae8ce5745",
    personId: "d92c06bf-af49-48c3-9550-cfc5c7aceabd",
    license: "YPAL",
    state: "PA",
    createdBy: "29421a23-1403-404e-8669-f6b53c55563f",
    createdIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    createdAt: "2020-06-23T20:15:09.822015Z",
    updatedBy: "29421a23-1403-404e-8669-f6b53c55563f",
    updatedIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    updatedAt: "2020-06-23T20:15:11.418668Z",
    hasMembership: false,
    isVerified: false,
    isTemporaryIdentifier: false,
    verificationCode: "",
  },
  {
    vehicleId: "f43bf551-a149-4dc0-9790-ab58758f5319",
    personId: "d92c06bf-af49-48c3-9550-cfc5c7aceabd",
    license: "",
    state: "",
    createdBy: "29421a23-1403-404e-8669-f6b53c55563f",
    createdIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    createdAt: "2020-06-23T20:17:15.381719Z",
    updatedBy: "29421a23-1403-404e-8669-f6b53c55563f",
    updatedIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    updatedAt: "2020-06-23T20:17:15.431017Z",
    make: "Ram",
    model: "1500 Laramie Longhorn Crew Cab",
    year: "2013",
    vin: "WP0AB2A86QZ120783",
    hasMembership: true,
    isVerified: false,
    isTemporaryIdentifier: true,
    verificationCode: "",
  },
  {
    vehicleId: "0BAC7999-C921-4DE1-9F8E-4BD6546D98FA",
    personId: "d92c06bf-af49-48c3-9550-cfc5c7aceabd",
    license: "12345",
    state: "TN",
    createdBy: "29421a23-1403-404e-8669-f6b53c55563f",
    createdIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    createdAt: "2020-06-23T20:17:15.381719Z",
    updatedBy: "29421a23-1403-404e-8669-f6b53c55563f",
    updatedIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    updatedAt: "2020-06-23T20:17:15.431017Z",
    hasMembership: true,
    isVerified: true,
    isTemporaryIdentifier: false,
    verificationCode: "",
  },
];

export const MOCK_ACCOUNT: Account = {
  personId: "d92c06bf-af49-48c3-9550-cfc5c7aceabd",
  xrefId: null,
  firstName: null,
  lastName: null,
  memberSince: null,
  birthDate: null,
  gender: null,
  email: null,
  primaryPh: null,
  secondaryPh: null,
  stripeCustomer: "cus_HWLEyB0xAiQLjj",
  homeStoreId: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
  street1: null,
  street2: null,
  city: null,
  state: null,
  countryId: null,
  zipCode: null,
  createdBy: "29421a23-1403-404e-8669-f6b53c55563f",
  createdIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
  createdAt: "2020-06-23T20:15:10.635814Z",
  updatedBy: "29421a23-1403-404e-8669-f6b53c55563f",
  updatedIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
  updatedAt: "2020-06-23T20:16:33.964509Z",
  regionNumber: "72",
};

export const MOCK_QSYS_ACCOUNT: QsysProfile = {
  userName: "awesometest@gmail.com",
  name: "Awesome Test",
  info: {
    address: "5001 Lexington Street",
    gender: "∅",
    height: 187,
    qsysAccount: "d92c06bf-af49-48c3-9550-cfc5c7aceabd",
  },
};

export const MOCK_ACTIVE_COUPONS = [
  {
    couponIssuedId: "a8525ef8-050c-4a6d-b4d7-2ccae34ff91c",
    orderItemId: "64c014ee-1028-4bd3-a8ea-65ccc81542fa",
    couponId: "3e184456-fe92-527b-8af2-fad8ea8f9c56",
    personId: "d92c06bf-af49-48c3-9550-cfc5c7aceabd",
    vehicleId: "92a7c406-7ded-4fee-8b69-0c8ae8ce5745",
    storeId: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    employeeId: "29421a23-1403-404e-8669-f6b53c55563f",
    stripePlanId: "plan_HKJFyx1A1Jf9uG",
    isActive: true,
    effectiveAt: "2020-06-23T20:16:26Z",
    expiresAt: "2020-07-24T07:00:00Z",
    createdBy: "29421a23-1403-404e-8669-f6b53c55563f",
    createdIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    createdAt: "2020-06-23T20:16:33.411979Z",
    updatedBy: "29421a23-1403-404e-8669-f6b53c55563f",
    updatedIn: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
    updatedAt: "2020-06-23T20:16:33.471662Z",
  },
];

export const MOCK_PROFILE: GetProfileResponse = {
  profile: MOCK_QSYS_ACCOUNT,
  membership: {
    account: MOCK_ACCOUNT,
    vehicles: MOCK_VEHICLES,
    activeCoupons: MOCK_ACTIVE_COUPONS,
  },
};

export const MOCK_ORDER_HEADER_1: OrderHeader = {
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  storeId: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
  storeNumber: "0701",
  storeState: "CO",
  storeCity: "Colorado Springs",
  regionId: "2cbc6b9c-d22f-5c12-a509-682e77c6f8d4",
  regionNumber: "07",
  customerId: "9ee34fbe-8a3f-4b81-b042-afc7dfa3001f",
  custFirstName: "Sub",
  custLastName: "1 flock",
  cashierId: "f0a218b7-6ac4-57ca-ad99-997f707e353b",
  cashierFirstName: "Admin",
  cashierLastName: "Site Master",
  deviceId: "f4d55b53-ee4d-42bc-8361-bc1b2a719fc8",
  lane: 1,
  orderType: OrderTypesEnum.STORE,
  orderStatus: "COMPLETED",
  isNewCustomer: false,
  isEmployee: false,
  totalTaxable: "0",
  totalMarkDowns: "0",
  totalMarkUps: "0",
  subTotal: "21.49",
  orderTotal: "21.49",
  submissionAt: "2020-06-16T00:00:00Z",
  submissionTime: "2020-06-16T17:29:04Z",
  vehicleVin: "",
  vehicleState: "TN",
  vehicleLicense: "ABC123",
  laneType: "",
  washType: MockGoodWashLevelName,
  description: "Carwash Purchase",
};

export const MOCK_ORDER_HEADER_2: OrderHeader = {
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  storeId: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
  storeNumber: "0701",
  storeState: "CO",
  storeCity: "Colorado Springs",
  regionId: "2cbc6b9c-d22f-5c12-a509-682e77c6f8d4",
  regionNumber: "07",
  customerId: "9ee34fbe-8a3f-4b81-b042-afc7dfa3001f",
  custFirstName: "Sub",
  custLastName: "1 flock",
  cashierId: "f0a218b7-6ac4-57ca-ad99-997f707e353b",
  cashierFirstName: "Admin",
  cashierLastName: "Site Master",
  deviceId: "f4d55b53-ee4d-42bc-8361-bc1b2a719fc8",
  lane: 1,
  orderType: OrderTypesEnum.STORE,
  orderStatus: "COMPLETED",
  isNewCustomer: false,
  isEmployee: false,
  totalTaxable: "0",
  totalMarkDowns: "0",
  totalMarkUps: "0",
  subTotal: "21.49",
  orderTotal: "21.49",
  submissionAt: "2020-06-16T00:00:00Z",
  submissionTime: "2020-06-16T17:29:04Z",
  laneType: "",
  washType: MockBetterWashLevelName,
  description: "Carwash Purchase",
};

export const MOCK_ORDER_HEADER_3: OrderHeader = {
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  storeId: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
  storeNumber: "0701",
  storeState: "CO",
  storeCity: "Colorado Springs",
  regionId: "2cbc6b9c-d22f-5c12-a509-682e77c6f8d4",
  regionNumber: "07",
  customerId: "9ee34fbe-8a3f-4b81-b042-afc7dfa3001f",
  custFirstName: "Sub",
  custLastName: "1 flock",
  cashierId: "f0a218b7-6ac4-57ca-ad99-997f707e353b",
  cashierFirstName: "Admin",
  cashierLastName: "Site Master",
  deviceId: "f4d55b53-ee4d-42bc-8361-bc1b2a719fc8",
  lane: 1,
  orderType: OrderTypesEnum.STORE,
  orderStatus: "COMPLETED",
  isNewCustomer: false,
  isEmployee: false,
  totalTaxable: "0",
  totalMarkDowns: "0",
  totalMarkUps: "0",
  subTotal: "21.49",
  orderTotal: "21.49",
  submissionAt: "2020-06-16T00:00:00Z",
  submissionTime: "2020-06-16T17:29:04Z",
  laneType: "",
  washType: MockBestWashLevelName,
  description: "Carwash Purchase",
};

export const MOCK_ORDER_HEADER_4: OrderHeader = {
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  storeId: "7c411b5e-9d3f-50b5-9c28-62096e41c4ed",
  storeNumber: "0701",
  storeState: "CO",
  storeCity: "Colorado Springs",
  regionId: "2cbc6b9c-d22f-5c12-a509-682e77c6f8d4",
  regionNumber: "07",
  customerId: "9ee34fbe-8a3f-4b81-b042-afc7dfa3001f",
  custFirstName: "Sub",
  custLastName: "1 flock",
  cashierId: "f0a218b7-6ac4-57ca-ad99-997f707e353b",
  cashierFirstName: "Admin",
  cashierLastName: "Site Master",
  deviceId: "f4d55b53-ee4d-42bc-8361-bc1b2a719fc8",
  lane: 1,
  orderType: OrderTypesEnum.STORE,
  orderStatus: "COMPLETED",
  isNewCustomer: false,
  isEmployee: false,
  totalTaxable: "0",
  totalMarkDowns: "0",
  totalMarkUps: "0",
  subTotal: "21.49",
  orderTotal: "21.49",
  submissionAt: "2020-06-16T00:00:00Z",
  submissionTime: "2020-06-16T17:29:04Z",
  laneType: "",
  description: "Carwash Purchase",
};

export const MOCK_ORDER_ITEM_1: OrderItem = {
  orderItemId: "3ff77ab8-ee67-4454-9471-a3aa7b38c306",
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  itemId: "adde9d6f-0e5d-52d9-bd2a-8738f8e157b5",
  name: "Clean Membership Flock - Auto Pay",
  sku: "SUB-FLOCK-MB-C-030",
  vehicleId: "f43bf551-a149-4dc0-9790-ab58758f5317",
  orderedQty: "1",
  unitPrice: "15",
  totalTaxable: "0",
  taxRate: "0",
  priceInclTax: false,
  totalMarkDowns: "0",
  subTotal: "15",
  grossTotal: "15",
  taxTotal: "0",
  lineTotal: "15",
};

export const MOCK_ORDER_ITEM_2 = {
  orderItemId: "6c99cc19-7d5e-4782-aa16-e28790506599",
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  itemId: "adde9d6f-0e5d-52d9-bd2a-8738f8e157b5",
  name: "Clean Membership Flock - Auto Pay",
  sku: "SUB-FLOCK-MB-C-030",
  vehicleId: "92a7c406-7ded-4fee-8b69-0c8ae8ce5745",
  orderedQty: "1",
  unitPrice: "15",
  totalTaxable: "0",
  taxRate: "0",
  priceInclTax: false,
  totalMarkDowns: "0",
  subTotal: "15",
  grossTotal: "15",
  taxTotal: "0",
  lineTotal: "15",
};

export const MOCK_ORDER_ITEM_3: OrderItem = {
  orderItemId: "6f18a66c-8937-4536-9eb0-fd2f43b194e8",
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  itemId: "adde9d6f-0e5d-52d9-bd2a-8738f8e157b5",
  name: "Clean Membership Flock - Auto Pay",
  sku: "SUB-FLOCK-MB-C-030",
  vehicleId: "f43bf551-a149-4dc0-9790-ab58758f5319",
  orderedQty: "1",
  totalTaxable: "0",
  taxRate: "0",
  priceInclTax: false,
  totalMarkDowns: "0",
  subTotal: "15",
  grossTotal: "15",
  taxTotal: "0",
  lineTotal: "15",
};

export const MOCK_ORDER_ITEM_4: OrderItem = {
  orderItemId: "1642a9e7-63d1-4f60-9416-78b259df985d",
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  itemId: "9a3f1c27-6dac-574e-bec2-2579e8920fcb",
  name: "Clean Membership - Auto Pay",
  sku: "SUB-MB-C-030",
  vehicleId: "0BAC7999-C921-4DE1-9F8E-4BD6546D98FA",
  orderedQty: "1",
  unitPrice: "22.99",
  totalTaxable: "0",
  taxRate: "0",
  priceInclTax: false,
  totalMarkDowns: "0",
  subTotal: "22.99",
  grossTotal: "22.99",
  taxTotal: "0",
  lineTotal: "22.99",
};

export const MOCK_ORDER_1: Order = {
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  storeId: "4b166dbe-d99d-5091-abdd-95b83330ed3a",
  regionId: "408e52a1-b0bc-5dcc-a589-5ea95caf56dc",
  customerId: "ae648167-a7c0-429e-b06b-cba9166a9c35",
  cashierId: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  deviceId: "96897aa3-94e3-42e3-823f-be2dadb361e0",
  membershipId: "6777bdcb-4ae8-5cc2-a995-02d7c3271509",
  stripeCustomerId: "cus_H5gU3Y4wKYA2sj",
  mbrCouponIssuedId: "5914ad0c-007a-4241-a657-eb9c04f43282",
  nextBillingAmount: "67.99",
  createReasonCode: "SALES",
  lane: 1,
  laneType: "",
  vehicleId: "3143854b-8808-43ce-8d4a-ae30843500ed",
  orderType: OrderTypesEnum.NEWMEMBERSHIP,
  orderStatus: "COMPLETED",
  isNewCustomer: false,
  isNewMember: false,
  isNewVehicle: true,
  isEmployee: false,
  isRewash: false,
  totalManualDiscount: "0",
  totalTaxable: "0",
  totalMarkDowns: "0",
  totalMarkUps: "0",
  subTotal: "67.99",
  taxTotal: "0",
  orderTotal: "67.99",
  submissionAt: "2020-07-22T16:37:53.586-06:00",
  submissionTime: "2020-07-22T16:37:53.586-06:00",
  createdBy: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  createdIn: "005694ea-dc67-67e6-fa8b-b05759853830",
  createdAt: "2020-07-22T15:37:58.71368645-07:00",
  updatedBy: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  updatedIn: "005694ea-dc67-67e6-fa8b-b05759853830",
  updatedAt: "2020-07-22T15:37:58.713686377-07:00",
  holds: [],
  items: [
    MOCK_ORDER_ITEM_1,
    MOCK_ORDER_ITEM_2,
    MOCK_ORDER_ITEM_3,
    MOCK_ORDER_ITEM_4,
  ],
  markDowns: [],
  markUps: [],
  payments: [
    {
      orderPaymentId: "2f9da02f-6fce-48c5-80ba-7854b2678d3d",
      orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
      paymentAmount: 1,
      paymentStatus: "PAID",
      paymentId: "pi_1HAJcWD1Fv1TB63CckfJzeEY",
      paymentType: "CREDIT",
      last4: "4444",
      expiresMonth: "12",
      expiresYear: "2022",
    },
    {
      orderPaymentId: "ee8af4f1-e409-446b-adb9-5d0a33023d53",
      orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
      paymentAmount: 0,
      paymentStatus: "PAID",
      paymentId: "pm_1HAJcSD1Fv1TB63C1UD5WqD8",
      paymentType: "CREDIT",
      last4: "4444",
      expiresMonth: "12",
      expiresYear: "2022",
    },
  ],
};

export const MOCK_ORDER_2: Order = {
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  storeId: "4b166dbe-d99d-5091-abdd-95b83330ed3a",
  regionId: "408e52a1-b0bc-5dcc-a589-5ea95caf56dc",
  customerId: "ae648167-a7c0-429e-b06b-cba9166a9c35",
  cashierId: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  deviceId: "96897aa3-94e3-42e3-823f-be2dadb361e0",
  membershipId: "6777bdcb-4ae8-5cc2-a995-02d7c3271509",
  stripeCustomerId: "cus_H5gU3Y4wKYA2sj",
  mbrCouponIssuedId: "5914ad0c-007a-4241-a657-eb9c04f43282",
  nextBillingAmount: "67.99",
  createReasonCode: "SALES",
  lane: 1,
  laneType: "",
  vehicleId: "3143854b-8808-43ce-8d4a-ae30843500ed",
  orderType: OrderTypesEnum.NEWMEMBERSHIP,
  orderStatus: "COMPLETED",
  isNewCustomer: false,
  isNewMember: false,
  isNewVehicle: true,
  isEmployee: false,
  isRewash: false,
  totalManualDiscount: "0",
  totalTaxable: "0",
  totalMarkDowns: "0",
  totalMarkUps: "0",
  subTotal: "67.99",
  taxTotal: "0",
  orderTotal: "67.99",
  submissionAt: "2020-07-22T16:37:53.586-06:00",
  submissionTime: "2020-07-22T16:37:53.586-06:00",
  createdBy: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  createdIn: "005694ea-dc67-67e6-fa8b-b05759853830",
  createdAt: "2020-07-22T15:37:58.71368645-07:00",
  updatedBy: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  updatedIn: "005694ea-dc67-67e6-fa8b-b05759853830",
  updatedAt: "2020-07-22T15:37:58.713686377-07:00",
  holds: [],
  items: [
    MOCK_ORDER_ITEM_1,
    MOCK_ORDER_ITEM_2,
    MOCK_ORDER_ITEM_3,
    MOCK_ORDER_ITEM_4,
  ],
  markDowns: [],
  markUps: [],
  payments: [
    {
      orderPaymentId: "2f9da02f-6fce-48c5-80ba-7854b2678d3d",
      orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
      paymentAmount: 1,
      paymentStatus: "PAID",
      paymentId: "pi_1HAJcWD1Fv1TB63CckfJzeEY",
      paymentType: "CREDIT",
      last4: "4444",
      expiresMonth: "12",
      expiresYear: "2022",
    },
    {
      orderPaymentId: "ee8af4f1-e409-446b-adb9-5d0a33023d53",
      orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
      paymentAmount: 0,
      paymentStatus: "PAID",
      paymentId: "pm_1HAJcSD1Fv1TB63C1UD5WqD8",
      paymentType: "CREDIT",
      last4: "4444",
      expiresMonth: "12",
      expiresYear: "2022",
    },
  ],
};

export const MOCK_ORDER_3: Order = {
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  storeId: "4b166dbe-d99d-5091-abdd-95b83330ed3a",
  regionId: "408e52a1-b0bc-5dcc-a589-5ea95caf56dc",
  customerId: "ae648167-a7c0-429e-b06b-cba9166a9c35",
  cashierId: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  deviceId: "96897aa3-94e3-42e3-823f-be2dadb361e0",
  membershipId: "6777bdcb-4ae8-5cc2-a995-02d7c3271509",
  stripeCustomerId: "cus_H5gU3Y4wKYA2sj",
  mbrCouponIssuedId: "5914ad0c-007a-4241-a657-eb9c04f43282",
  nextBillingAmount: "67.99",
  createReasonCode: "SALES",
  lane: 1,
  laneType: "",
  vehicleId: "3143854b-8808-43ce-8d4a-ae30843500ed",
  orderType: OrderTypesEnum.NEWMEMBERSHIP,
  orderStatus: "COMPLETED",
  isNewCustomer: false,
  isNewMember: false,
  isNewVehicle: true,
  isEmployee: false,
  isRewash: false,
  totalManualDiscount: "0",
  totalTaxable: "0",
  totalMarkDowns: "0",
  totalMarkUps: "0",
  subTotal: "67.99",
  taxTotal: "0",
  orderTotal: "67.99",
  submissionAt: "2020-07-22T16:37:53.586-06:00",
  submissionTime: "2020-07-22T16:37:53.586-06:00",
  createdBy: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  createdIn: "005694ea-dc67-67e6-fa8b-b05759853830",
  createdAt: "2020-07-22T15:37:58.71368645-07:00",
  updatedBy: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  updatedIn: "005694ea-dc67-67e6-fa8b-b05759853830",
  updatedAt: "2020-07-22T15:37:58.713686377-07:00",
  holds: [],
  items: [
    MOCK_ORDER_ITEM_1,
    MOCK_ORDER_ITEM_2,
    MOCK_ORDER_ITEM_3,
    MOCK_ORDER_ITEM_4,
  ],
  markDowns: [],
  markUps: [],
  payments: [
    {
      orderPaymentId: "2f9da02f-6fce-48c5-80ba-7854b2678d3d",
      orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
      paymentAmount: 1,
      paymentStatus: "PAID",
      paymentId: "pi_1HAJcWD1Fv1TB63CckfJzeEY",
      paymentType: "CREDIT",
      last4: "4444",
      expiresMonth: "12",
      expiresYear: "2022",
    },
    {
      orderPaymentId: "ee8af4f1-e409-446b-adb9-5d0a33023d53",
      orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
      paymentAmount: 0,
      paymentStatus: "PAID",
      paymentId: "pm_1HAJcSD1Fv1TB63C1UD5WqD8",
      paymentType: "CREDIT",
      last4: "4444",
      expiresMonth: "12",
      expiresYear: "2022",
    },
  ],
};

export const MOCK_ORDER_4: Order = {
  orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
  storeId: "4b166dbe-d99d-5091-abdd-95b83330ed3a",
  regionId: "408e52a1-b0bc-5dcc-a589-5ea95caf56dc",
  customerId: "ae648167-a7c0-429e-b06b-cba9166a9c35",
  cashierId: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  deviceId: "96897aa3-94e3-42e3-823f-be2dadb361e0",
  membershipId: "6777bdcb-4ae8-5cc2-a995-02d7c3271509",
  stripeCustomerId: "cus_H5gU3Y4wKYA2sj",
  mbrCouponIssuedId: "5914ad0c-007a-4241-a657-eb9c04f43282",
  nextBillingAmount: "67.99",
  createReasonCode: "SALES",
  lane: 1,
  laneType: "",
  vehicleId: "3143854b-8808-43ce-8d4a-ae30843500ed",
  orderType: OrderTypesEnum.NEWMEMBERSHIP,
  orderStatus: "COMPLETED",
  isNewCustomer: false,
  isNewMember: false,
  isNewVehicle: true,
  isEmployee: false,
  isRewash: false,
  totalManualDiscount: "0",
  totalTaxable: "0",
  totalMarkDowns: "0",
  totalMarkUps: "0",
  subTotal: "67.99",
  taxTotal: "0",
  orderTotal: "67.99",
  submissionAt: "2020-07-22T16:37:53.586-06:00",
  submissionTime: "2020-07-22T16:37:53.586-06:00",
  createdBy: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  createdIn: "005694ea-dc67-67e6-fa8b-b05759853830",
  createdAt: "2020-07-22T15:37:58.71368645-07:00",
  updatedBy: "f5dcc5f3-502e-5801-9e47-cdbfb972080c",
  updatedIn: "005694ea-dc67-67e6-fa8b-b05759853830",
  updatedAt: "2020-07-22T15:37:58.713686377-07:00",
  holds: [],
  items: [
    MOCK_ORDER_ITEM_1,
    MOCK_ORDER_ITEM_2,
    MOCK_ORDER_ITEM_3,
    MOCK_ORDER_ITEM_4,
  ],
  markDowns: [],
  markUps: [],
  payments: [
    {
      orderPaymentId: "2f9da02f-6fce-48c5-80ba-7854b2678d3d",
      orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
      paymentAmount: 1,
      paymentStatus: "PAID",
      paymentId: "pi_1HAJcWD1Fv1TB63CckfJzeEY",
      paymentType: "CREDIT",
      last4: "4444",
      expiresMonth: "12",
      expiresYear: "2022",
    },
    {
      orderPaymentId: "ee8af4f1-e409-446b-adb9-5d0a33023d53",
      orderId: "e22d16b6-e3ca-453c-88a4-d1f3087f2bd2",
      paymentAmount: 0,
      paymentStatus: "PAID",
      paymentId: "pm_1HAJcSD1Fv1TB63C1UD5WqD8",
      paymentType: "CREDIT",
      last4: "4444",
      expiresMonth: "12",
      expiresYear: "2022",
    },
  ],
};

export const MOCK_CUSTOMER_PAYMENT_METHOD: CustomerPaymentMethod = {
  customerPaymentId: "B1751D64-5F9B-49F8-B24E-5E9453C0BDA7",
  // id: "B1751D64-5F9B-49F8-B24E-5E9453C0BDA7",
  brand: "visa",
  expMonth: "04",
  expYear: "2024",
  last4: "0987",
  isDefault: true,
};

export const MOCK_PRICE_TABLE: RegionMenu = {
  storeId: "MOCK_STORE_ID",
  plans: [
    {
      base: {
        itemId: "GOOD_BASE_ID",
        myQQName: "Good - Auto Renew",
        sku: "GOOD_SKU",
        price: "19.99",
      },
      flock: {
        itemId: "GOOD_FLOCK_ID",
        myQQName: "Good - Flock Auto Renew",
        sku: "GOOD_FLOCK_SKU",
      },
      myQQShortDisplayName: MockGoodWashLevelName,
      features: ["Bug Breakdown", "Foam Wash", "Power Blow Dry"],
      position: 3,
      washHierarchy: 100,
      availableForPurchase: true,
      washLevelId: "",
      backgroundImageUrl: "",
      washLevelImageUrl: "",
    },
    {
      base: {
        itemId: "BETTER_BASE_ID",
        myQQName: "Better - Auto Renew",
        sku: "BETTER_SKU",
        price: "29.99",
      },
      flock: {
        itemId: "BETTER_FLOCK_ID",
        myQQName: "Better - Flock Auto Renew",
        sku: "BETTER_FLOCK_SKU",
      },
      myQQShortDisplayName: MockBetterWashLevelName,
      features: [
        "Bug Breakdown",
        "Foam Wash",
        "Power Blow Dry",
        "Triple Foam Wash",
        "Rain Repellent",
        "Wheel Bright & Tire Shine",
        "Undercarriage Rust Inhibitor",
      ],
      position: 2,
      washHierarchy: 200,
      availableForPurchase: false,
      washLevelId: "65c60175-f52b-47a7-8260-a614f9584d8b",
      backgroundImageUrl: "",
      washLevelImageUrl: "",
    },
    {
      base: {
        itemId: "BEST_BASE_ID",
        myQQName: "Best - Auto Renew",
        sku: "BEST_SKU",
        price: "39.99",
      },
      flock: {
        itemId: "BEST_FLOCK_ID",
        name: "Best Flock- Auto Renew",
        myQQName: "Best Flock - Auto Renew",
        sku: "BEST_FLOCK_SKU",
        price: "19.99",
      },
      myQQShortDisplayName: MockBestWashLevelName,
      features: [
        "Bug Breakdown",
        "Foam Wash",
        "Power Blow Dry",
        "Triple Foam Wash",
        "Rain Repellent",
        "Wheel Bright & Tire Shine",
        "Undercarriage Rust Inhibitor",
        "3-Step Paint Sealant Process",
        "Duck Bath",
        "Ultra Shine",
        "Wax to seal",
      ],
      position: 1,
      washHierarchy: 300,
      availableForPurchase: true,
      washLevelId: "",
      backgroundImageUrl: "",
      washLevelImageUrl: "",
    },
    {
      base: {
        itemId: "CERAMIC_BASE_ID",
        myQQName: "Ceramic - Auto Renew",
        sku: "CERAMIC_SKU",
        price: "49.99",
      },
      flock: {
        itemId: "CERAMIC_FLOCK_ID",
        name: "CERAMIC Flock- Auto Renew",
        myQQName: "Ceramic Flock - Auto Renew",
        sku: "CERAMIC_FLOCK_SKU",
        price: "19.99",
      },
      myQQShortDisplayName: MockCeramicWashLevelName,
      features: [
        "Bug Breakdown",
        "Foam Wash",
        "Power Blow Dry",
        "Triple Foam Wash",
        "Rain Repellent",
        "Wheel Bright & Tire Shine",
        "Undercarriage Rust Inhibitor",
        "3-Step Paint Sealant Process",
        "Duck Bath",
        "Ultra Shine",
        "Wax to seal",
        "Ceramic",
      ],
      position: 0,
      washHierarchy: 400,
      availableForPurchase: true,
      washLevelId: "",
      backgroundImageUrl: "",
      washLevelImageUrl: "",
    },
  ],
};

export const MOCK_PRICE_TABLE_WITHOUT_PRICE: RegionMenu = {
  storeId: "MOCK_STORE_ID",
  plans: [
    {
      base: {
        itemId: "GOOD_BASE_ID",
        myQQName: "Good - Auto Renew",
        sku: "GOOD_SKU",
      },
      flock: {
        itemId: "GOOD_FLOCK_ID",
        myQQName: "Good - Flock Auto Renew",
        sku: "GOOD_FLOCK_SKU",
      },
      myQQShortDisplayName: MockGoodWashLevelName,
      features: ["Bug Breakdown", "Foam Wash", "Power Blow Dry"],
      position: 3,
      washHierarchy: 100,
      availableForPurchase: true,
      washLevelId: "",
      backgroundImageUrl: "",
      washLevelImageUrl: "",
    },
    {
      base: {
        itemId: "BETTER_BASE_ID",
        myQQName: "Better - Auto Renew",
        sku: "BETTER_SKU",
      },
      flock: {
        itemId: "BETTER_FLOCK_ID",
        myQQName: "Better - Flock Auto Renew",
        sku: "BETTER_FLOCK_SKU",
      },
      myQQShortDisplayName: MockBetterWashLevelName,
      features: [
        "Bug Breakdown",
        "Foam Wash",
        "Power Blow Dry",
        "Triple Foam Wash",
        "Rain Repellent",
        "Wheel Bright & Tire Shine",
        "Undercarriage Rust Inhibitor",
      ],
      position: 2,
      washHierarchy: 200,
      availableForPurchase: false,
      washLevelId: "65c60175-f52b-47a7-8260-a614f9584d8b",
      backgroundImageUrl: "",
      washLevelImageUrl: "",
    },
    {
      base: {
        itemId: "BEST_BASE_ID",
        myQQName: "Best - Auto Renew",
        sku: "BEST_SKU",
      },
      flock: {
        itemId: "BEST_FLOCK_ID",
        name: "Best Flock- Auto Renew",
        myQQName: "Best Flock - Auto Renew",
        sku: "BEST_FLOCK_SKU",
      },
      myQQShortDisplayName: MockBestWashLevelName,
      features: [
        "Bug Breakdown",
        "Foam Wash",
        "Power Blow Dry",
        "Triple Foam Wash",
        "Rain Repellent",
        "Wheel Bright & Tire Shine",
        "Undercarriage Rust Inhibitor",
        "3-Step Paint Sealant Process",
        "Duck Bath",
        "Ultra Shine",
        "Wax to seal",
      ],
      position: 1,
      washHierarchy: 300,
      availableForPurchase: true,
      washLevelId: "",
      backgroundImageUrl: "",
      washLevelImageUrl: "",
    },
    {
      base: {
        itemId: "CERAMIC_BASE_ID",
        myQQName: "Ceramic - Auto Renew",
        sku: "CERAMIC_SKU",
      },
      flock: {
        itemId: "CERAMIC_FLOCK_ID",
        name: "CERAMIC Flock- Auto Renew",
        myQQName: "Ceramic Flock - Auto Renew",
        sku: "CERAMIC_FLOCK_SKU",
      },
      myQQShortDisplayName: MockCeramicWashLevelName,
      features: [
        "Bug Breakdown",
        "Foam Wash",
        "Power Blow Dry",
        "Triple Foam Wash",
        "Rain Repellent",
        "Wheel Bright & Tire Shine",
        "Undercarriage Rust Inhibitor",
        "3-Step Paint Sealant Process",
        "Duck Bath",
        "Ultra Shine",
        "Wax to seal",
        "Ceramic",
      ],
      position: 0,
      washHierarchy: 400,
      availableForPurchase: true,
      washLevelId: "",
      backgroundImageUrl: "",
      washLevelImageUrl: "",
    },
  ],
};

export const MOCK_PROMO = {
  couponId: "d6766937-f0e9-408c-a7d5-ae78a59f6c02",
  couponType: "TRIAL SUBSCRIPTION",
  serialNo: "8001739",
  name: "600 | Entertainment Book Offer (Half Off ANY Single)",
  markDownId: "487277fa-ade7-4fd1-af7e-5d297a51853b",
  singleUse: false,
  totalIssued: 0,
  maxRedemptions: 0,
  remainingRedemptions: 0,
  limitRedemptions: false,
  durationQty: 30,
  isActive: true,
  effectiveAt: "2020-06-02T17:00:00-07:00",
  expiresAt: "2020-09-01T01:00:00-07:00",
};

export const MOCK_SUBSCRIPTION: SubscriptionDetail = {
  renewalDate: "2020-07-21T01:06:52.783Z",
  renewalAmount: "19.99",
  discountAmount: "0.00",
  renewalAmountBeforeDiscount: "19.99",
  subscriptionItems: [
    {
      itemId: "3368999f-28e4-5c19-bc60-98c6a24f71cd",
      name: "Better 30 Day Subscription",
      sku: "SUB-MB-P-030",
      amount: "24.99",
      quantity: 1,
      itemType: SubscriptionItemTypeEnum.base,
    },
    {
      itemId: "0f64bb6c-325e-5c7f-a0bc-335e60c938d1",
      name: "Better 30 Day Subscription Flock",
      sku: "SUB-FLOCK-MB-P-030",
      amount: "15",
      quantity: 1,
      itemType: SubscriptionItemTypeEnum.flock,
    },
  ],
  vehicles: MOCK_VEHICLES,
  status: "past_due",
  stripeSubscription: {
    cancel_at_period_end: false,
    cancel_at: null,
  } as Stripe.Subscription,
  washLevelId: "65c60175-f52b-47a7-8260-a614f9584d8b",
  myQQShortDisplayName: "better",
  regionNumber: "72",
};

export const MOCK_REGIONS = [
  {
    regionId: "e8497eef-cd28-5a60-ba47-6ec9531e2025",
    regionNumber: "06",
    name: "CA - Sacramento",
    state: "CA",
    timeZone: "America/Los_Angeles",
    createdAt: "2019-05-24T05:29:44.686118Z",
    updatedAt: "2019-05-24T05:29:44.686118Z",
  },
  {
    regionId: "5fd2aa8a-71f5-5f40-993c-c41d79ac2ed8",
    regionNumber: "99",
    name: "Service Center",
    state: "CA",
    timeZone: "America/Los_Angeles",
    createdAt: "2019-05-24T05:29:44.616884Z",
    updatedAt: "2019-05-24T05:29:44.616884Z",
  },
  {
    regionId: "7f6d7bae-f35d-5846-9f0f-5b87644b6a94",
    regionNumber: "03",
    name: "CA - Coachella Valley",
    state: "CA",
    timeZone: "America/Los_Angeles",
    createdAt: "2019-05-24T05:29:44.686094Z",
    updatedAt: "2019-05-24T05:29:44.686094Z",
  },
  {
    regionId: "408e52a1-b0bc-5dcc-a589-5ea95caf56dc",
    regionNumber: "01",
    name: "TX - Amarillo",
    state: "TX",
    timeZone: "America/Chicago",
    createdAt: "2019-05-24T05:29:44.686056Z",
    updatedAt: "2019-05-24T05:29:44.686056Z",
  },
  {
    regionId: "ca5b1793-e4e1-524d-bc76-e3938ec24601",
    regionNumber: "02",
    name: "TX - Houston",
    state: "TX",
    timeZone: "America/Chicago",
    createdAt: "2019-05-24T05:29:44.686031Z",
    updatedAt: "2019-05-24T05:29:44.686031Z",
  },
  {
    regionId: "52d1a192-8401-5400-96e8-3012cc81865c",
    regionNumber: "04",
    name: "CA - Inland Empire",
    state: "CA",
    timeZone: "America/Los_Angeles",
    createdAt: "2019-05-24T05:29:44.686212Z",
    updatedAt: "2019-05-24T05:29:44.686212Z",
  },
  {
    regionId: "e16d92de-07ad-53f2-8ec1-9838dd12205d",
    regionNumber: "05",
    name: "UT - Utah",
    state: "UT",
    timeZone: "America/Denver",
    createdAt: "2019-05-24T05:29:44.68616Z",
    updatedAt: "2019-05-24T05:29:44.686161Z",
  },
  {
    regionId: "2cbc6b9c-d22f-5c12-a509-682e77c6f8d4",
    regionNumber: "07",
    name: "CO - Colorado Springs",
    state: "CO",
    timeZone: "America/Denver",
    createdAt: "2019-05-24T05:29:44.686072Z",
    updatedAt: "2019-05-24T05:29:44.686072Z",
  },
  {
    regionId: "bc6141e0-8428-5f97-a237-b5e237bb41b5",
    regionNumber: "08",
    name: "CA - Bay Area",
    state: "CA",
    timeZone: "America/Los_Angeles",
    createdAt: "2019-05-24T05:29:44.686197Z",
    updatedAt: "2019-05-24T05:29:44.686197Z",
  },
  {
    regionId: "8e96af37-2996-5471-a339-aeb81ebe90fd",
    regionNumber: "11",
    name: "TX - Lubbock",
    state: "TX",
    timeZone: "America/Chicago",
    createdAt: "2019-05-24T05:29:44.686008Z",
    updatedAt: "2019-05-24T05:29:44.686008Z",
  },
  {
    regionId: "1d2f37a3-973f-5dc8-8e67-5b715d74ff99",
    regionNumber: "09",
    name: "AZ - Arizona",
    state: "AZ",
    timeZone: "America/Chicago",
    createdAt: "2019-05-24T05:29:44.686176Z",
    updatedAt: "2019-05-24T05:29:44.686176Z",
  },
  {
    regionId: "a8f37ee3-f2c0-02bf-e67e-7d5892ed171a",
    regionNumber: "12",
    name: "Corpus Christi",
    state: "TX",
    timeZone: "America/Chicago",
    createdBy: "8afb0866-19f1-4691-a302-78c64781c459",
    createdAt: "2020-01-30T21:23:55.031658Z",
    updatedBy: "8afb0866-19f1-4691-a302-78c64781c459",
    updatedAt: "2020-01-30T21:23:55.039514Z",
  },
];

export const MOCK_ACCOUNT_CHECK: AccountCheckResponse = {
  type: "found_one_no_link",
  ...MOCK_PROFILE,
  stripeSubscription: MOCK_SUBSCRIPTION,
};

/**
 * Account Info
 */
export const MOCK_ACCOUNT_INFO: AccountInfoResponse = {
  account: {
    account: MOCK_ACCOUNT,
    activeCoupons: MOCK_ACTIVE_COUPONS,
    vehicles: MOCK_VEHICLES,
    stripeSubscription: {
      currentPeriodEnd: "0",
      currentPeriodStart: "0",
      invoiceAmount: "19.99",
      invoiceId: "FAKE",
      status: StripeStatusEnum.ACTIVE,
      stripeVehicles: MOCK_VEHICLES,
      upcomingInvoice: null,
      cancelAtPeriodEnd: false,
    },
  },
  profile: MOCK_PROFILE.profile,
};

// URI prefixes for social media sites
export const SOCIAL_MEDIA_LINKS = {
  instagram: "https://www.instagram.com/",
  facebook: "https://www.facebook.com/",
  snapchat: "https://www.snapchat.com/add/",
  twitter: "https://www.twitter.com/",
  youtube: "https://www.youtube.com/user/",
};

export const MOCK_PROMO_DETAILS = {
  code: "promo",
} as PromoDetails;

export const MOCK_PLAN_SPECIFIC_UPGRADE_DETAILS = {
  code: "",
  autoApplyOrderTypes: ["UPGRADESUBSCRIPTION"],
  planSpecificOverride: [
    {
      position: 0,
      type: "CERAMIC",
      svg: MockPlansPromoSvg,
      serialNo: "FREECERAMICUPGRADE",
      sku: "SUB-MB-R-030",
    },
  ],
  companyWidePromo: true,
  autoApplyEffectiveAt: "2023-05-01T00:00:00-07:00",
  autoApplyExpiresAt: "2023-08-14T23:59:59-07:00",
};

export const MOCK_ACCOUNT_QUOTA: AccountQuota = {
  quotaAllowed: 2,
  quotaConsumed: 0,
};

export const MOCK_SWAP_REASONS: SwapReason[] = [
  {
    id: "f30a2a23-6918-4575-9cac-b2c2710c6fbc",
    name: "Received new plates",
    description: "",
    quotaConsumed: 1,
  },
  {
    id: "b1e59eea-6a9a-4fd7-887c-1b265daf0c1f",
    name: "Bought new car",
    description: "",
    quotaConsumed: 1,
  },
  {
    id: "8c9c36c7-4ec9-4526-abc9-dc7430a08618",
    name: "Transfer membership to another car",
    description: "",
    quotaConsumed: 1,
  },
];

export const MOCK_VEHICLE_SWAP_RESPONSE: VehicleSwapResponse = {
  currentVehicleId: "f43bf551-a149-4dc0-9790-ab58758f5317",
  newVehicleId: "92a7c406-7ded-4fee-8b69-0c8ae8ce5745",
  quotaConsumed: {
    quotaAllowed: 2,
    quotaConsumed: 1,
  },
};

export const MOCK_CANCEL_REASONS: CancelReason[] = [
  { message: "I moved", code: "MOVED" },
  { message: "I no longer use the membership on this car", code: "NONUSE" },
  { message: "I sold this car", code: "SOLDCAR" },
  { message: "This car is damaged", code: "DAMAGED" },
  { message: "This car has been modified ", code: "INCOMPATIBLE" },
  { message: "Weather has kept me from using the wash", code: "WEATHER" },
  { message: "I’m unsatisfied with my wash experience", code: "UNSATISFIED" },
  { message: "This is too expensive", code: "FINANCIAL" },
  { message: "I added this car by mistake", code: "SIGNUPERROR" },
  { message: "Other", code: "OTHER" },
];

export const MOCK_GRANDOPENING_PROMO = {
  code: "COSPRINGS",
  disclaimer:
    "Requires $1 activation fee. Valid at participating locations only. Requires autopay. After 30 days, card will be charged regular membership rate based on the plan selected. Early termination fee may apply. Offer subject to change, see email for expiration date.",
  customOverride: MockPlansPromoSvg,
  grandOpening: true,
  grandOpeningHomeStoreId: "3817533e-1950-4636-982b-f8972b52e7bb",
  autoApplyOrderTypes: [OrderTypesEnum.NEWMEMBERSHIP],
  crossOutDefaultPrice: true,
  planSpecificOverride: [
    {
      position: 0,
      type: "good",
      serialNo: "COSPRINGS",
      fixedBasePrice: "1",
      fixedFlockPrice: "1",
      sku: "SUB-MB-S-030",
    },
    {
      position: 0,
      type: "better",
      serialNo: "COSPRINGS",
      fixedBasePrice: "1",
      fixedFlockPrice: "1",
      sku: "SUB-MB-P-030",
    },
    {
      position: 0,
      type: "best",
      serialNo: "COSPRINGS",
      fixedBasePrice: "1",
      fixedFlockPrice: "1",
      sku: "SUB-MB-T-030",
    },
    {
      position: 0,
      type: "ceramic",
      serialNo: "COSPRINGS",
      fixedBasePrice: "1",
      fixedFlockPrice: "1",
      sku: "SUB-MB-R-030",
    },
  ],
  companyWidePromo: true,
  autoApplyEffectiveAt: null,
  autoApplyExpiresAt: null,
};

export const MOCK_FLOCK_ONLY_PROMO = {
  code: "QQFAST",
  disclaimer: "",
  autoApplyOrderTypes: [OrderTypesEnum.ADDMEMBERSHIP],
  crossOutDefaultPrice: false,
  VehiclePageSvg: MockPlansPromoSvg,
  planSpecificOverride: [
    {
      position: 0,
      type: "good",
      serialNo: "QQFAST",
      sku: "SUB-MB-S-030",
    },
    {
      position: 0,
      type: "better",
      serialNo: "QQFAST",

      sku: "SUB-MB-P-030",
    },
    {
      position: 0,
      type: "best",
      serialNo: "QQFAST",
      sku: "SUB-MB-T-030",
    },
    {
      position: 0,
      type: "ceramic",
      serialNo: "QQFAST",
      sku: "SUB-MB-R-030",
    },
  ],
  companyWidePromo: true,
  autoApplyEffectiveAt: null,
  autoApplyExpiresAt: null,
};

export const MOCK_FLOCK_AND_NEW_MEMBERSHIP_PROMO = {
  code: "QQFAST",
  disclaimer: "",
  customOverride: MockPlansPromoSvg,
  autoApplyOrderTypes: [OrderTypesEnum.ADDMEMBERSHIP],
  crossOutDefaultPrice: false,
  VehiclePageSvg: MockPlansPromoSvg,
  planSpecificOverride: [
    {
      position: 0,
      type: "good",
      serialNo: "QQFAST",
      sku: "SUB-MB-S-030",
    },
    {
      position: 0,
      type: "better",
      serialNo: "QQFAST",

      sku: "SUB-MB-P-030",
    },
    {
      position: 0,
      type: "best",
      serialNo: "QQFAST",
      sku: "SUB-MB-T-030",
    },
    {
      position: 0,
      type: "ceramic",
      serialNo: "QQFAST",
      sku: "SUB-MB-R-030",
    },
  ],
  companyWidePromo: true,
  autoApplyEffectiveAt: null,
  autoApplyExpiresAt: null,
};

export const MOCK_B2B_BENEFIT = {
  companyName: "Corwin Inc",
  contractDescription: "50% off 1 vehicle",
  planSpecificBenefit: [
    {
      benefitDescription: "",
      contractId: "",
      crossOutBasePrice: true,
      itemId: "",
      sku: "",
    },
  ],
};

export const MOCK_GRAND_OPENING: GrandOpening = {
  wash2winChoiceUrl: "http://localhost:4200/grandopening/2601/wash2win",
  wash2winUnlimitedUrl: "http://localhost:4200/grandopening/2601/unlimitedwash",
  wash2winLimitedUrl: "http://localhost:4200/grandopening/2601/limitedwash",
  wash2winTitle: "Folsom Grand Opening",
  wash2winHeader:
    "Play our free Wash to Win game for a chance to win up to 1 year of free Quick Quack Car Washes!",
  wash2winSubHeader:
    "Thank you so much for celebrating the Grand Opening of our new location with us and giving Quick Quack a try! We hope you had an exceptional experience. As a small token of our appreciation, we’ve created a fun free contest with even more opportunities to win freebies. Enter below!",
  wash2winHowToPlay: `
    <div style="display: flex; justify-content: center; align-items: center; padding: 20px;">
      <div style="background-color: #ffffff; padding: 40px; border-radius: 8px; box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); max-width: 500px; text-align: center;">
        <h1 style="color: #1a7431; font-size: 2.5em; font-weight: bold; margin-top: 0; margin-bottom: 30px;">
            HOW TO PLAY:
        </h1>

        <ol style="text-align: left; display: inline-block; margin-bottom: 30px; font-size: 1.1em; line-height: 1.6; color: #333; padding-left: 30px; margin-top: 0;">
            <li style="margin-bottom: 10px;">We'll instantly email you a barcode to redeem your prize.</li>
            <li>Print the barcode or bring your phone to 297 E Hospitality Lane San Bernardino, CA, 92408 to redeem!</li>
        </ol>

        <p style="margin: 15px 0; font-size: 1.1em; font-style: italic; color: #555;">
            It's that easy!
        </p>
        
        <p style="margin: 15px 0; font-size: 1.1em; font-weight: bold; color: #333;">
            Good luck to all you lucky ducks!
        </p>

        <p style="margin: 15px 0 0; font-size: 1.1em;">
            Not a member yet? 
            <a href="#" style="color: #1a7431; text-decoration: underline; font-weight: bold;">CLICK HERE!</a>
        </p>
      </div>
    </div>`,
  wash2winFeatherFormId: "zrN4e8",
  wash2winUnlimitedPrizes: [
    "https://cdn.sanity.io/images/my7y6c1m/dev/02591492f37513c52f5c07817fb6bb8b32a41429-280x280.webp",
    "https://cdn.sanity.io/images/my7y6c1m/dev/48aa5d31f6ad77868db39eb7f8fe4cef77f4db7e-280x280.webp",
  ],
  wash2winLimitedPrizes: [
    "https://cdn.sanity.io/images/my7y6c1m/dev/02591492f37513c52f5c07817fb6bb8b32a41429-280x280.webp",
  ],
  wash2winStartDate: "2025-06-17T17:46:00Z",
  wash2winEndDate: "2025-07-31T17:47:00Z",
  termsAndConditions: `Eligibility: This Campaign is open only to those who sign up at the Quick Quack Car Wash website and who are 18 years of age or older as of the date of entry. The Campaign is only open to legal residents of the United States and is void where prohibited by law. Employees of Quick Quack Car Wash, its affiliates, subsidiaries, advertising and promotion agencies, and suppliers (collectively the “Employees”), and immediate family members and/or those living in the same household of Employees are not eligible to participate in the Campaign. The Campaign is subject to all applicable federal, state, and local laws and regulations. Void where prohibited.

Agreement to Rules: By participating, the Contestant (“You”) agree to be fully unconditionally bound by these Rules, and You represent and warrant that You meet the eligibility requirements. In addition, you agree to accept the decisions of Quick Quack Car Wash as final and binding as it relates to the content of this Campaign.

Campaign Period: Entries will be accepted online beginning 03/19/25 and ending 06/19/25. The Grand Prize winner will be announced 6/20/25. All online entries must be received by 297 E Hospitality Lane at 11:59 PM PST.

How to Enter: The Campaign must be entered by submitting an entry using the online form provided at https://www.dontdrivedirty.com/w2w_4423. The entry must fulfill all Campaign requirements, as specified, to be eligible to win a prize. Entries that are incomplete or do not adhere to the rules or specifications may be disqualified at the sole discretion of Quick Quack Car Wash. You may enter only once. You must provide the information requested. You may not enter more times than indicated by using multiple email addresses, identities, or devices in an attempt to circumvent the rules. If You use fraudulent methods or otherwise attempt to circumvent the rules, your submission may be removed from eligibility at the sole discretion of Quick Quack Car Wash.

Prizes: All entrants are eligible to win a free year of Unlimited “Ceramic” washes, a free air freshener, or a free towel. No cash or other prize substitution shall be permitted except at the discretion of Quick Quack Car Wash. The prize is nontransferable. Any and all prize-related expenses, including without limitation any and all federal, state, and/or local taxes, shall be the sole responsibility of the Winner. No substitution of prize or transfer/assignment of prize to others or request for the cash equivalent by Winner is permitted. Acceptance of prize constitutes permission for Quick Quack Car Wash to use Winner’s name, likeness, and entry for purposes of advertising and trade without further compensation, unless prohibited by law. 

Grand Prize: The Grand Prize Winner of the Campaign (the “Winner”) will receive one (1) Grand Prize: one year of free Unlimited “Ceramic” washes. The specifics of the prize shall be solely determined by Quick Quack Car Wash. No cash or other prize substitution shall be permitted except at the discretion of Quick Quack Car Wash. The prize is nontransferable. Any and all prize-related expenses, including without limitation any and all federal, state, and/or local taxes, shall be the sole responsibility of Winner. No substitution of prize or transfer/assignment of prize to others or request for the cash equivalent by Winner is permitted. Acceptance of prize constitutes permission for Quick Quack Car Wash to use Winner’s name, likeness, and entry for purposes of advertising and trade without further compensation, unless prohibited by law. 

Odds: The odds of winning depend on the number of eligible entries received, 1 per person.

Winner Selection and Notification: Winner will be selected by a random drawing under the supervision of Quick Quack Car Wash. Winner will be notified by email and/or social media within five (5) days following selection of Winner. Quick Quack Car Wash shall have no liability for Winner’s failure to receive notices due to spam, junk e-mail or other security settings or for Winner’s provision of incorrect or otherwise non-functioning contact information. If Winner cannot be contacted, is ineligible, fails to claim the prize within 10 days from the time award notification was sent, fails to timely return a completed and executed declaration and release as required, or is unwilling or unable to cover the taxes and fees, the prize may be forfeited and an alternate Winner selected. Receipt by Winner of the prize offered in this Campaign is conditioned upon compliance with any and all federal, state, and local laws and regulations. ANY VIOLATION OF THESE OFFICIAL RULES BY WINNER AT THE SOLE DISCRETION OF QUICK QUACK CAR WASH WILL RESULT IN WINNER’S DISQUALIFICATION AS WINNER OF THE CAMPAIGN, AND ALL PRIVILEGES AS WINNER WILL BE IMMEDIATELY TERMINATED. Please label your envelope “Wash-to-Win Contest”. Rights Granted by You: By entering this contest, You understand and agree that Quick Quack Car Wash, anyone acting on behalf of Quick Quack Car Wash and Quick Quack Car Wash’s licensees, successors, and assigns, shall have the right, where permitted by law, to print, publish, broadcast, distribute, and use in any media now known or hereafter developed, in perpetuity and throughout the World, without limitation, your entry, name, portrait, picture, voice, likeness, image, statements about the Campaign, and biographical information for news, publicity, information, trade, advertising, public relations, and promotional purposes. without any further compensation, notice, review, or consent.

Terms & Conditions: Quick Quack Car Wash reserves the right, in its sole discretion, to cancel, terminate, modify or suspend the Campaign should virus, bug, non-authorized human intervention, fraud, or other cause beyond Quick Quack Car Wash ’s control corrupt or affect the administration, security, fairness, or proper conduct of the Campaign. In such case, Quick Quack Car Wash may select the Winner from all eligible entries received prior to and/or after (if appropriate) the action taken by Quick Quack Car Wash. Quick Quack Car Wash reserves the right, in its sole discretion, to disqualify any individual who tampers or attempts to tamper with the entry process or the operation of the Campaign or website or violates these Terms & Conditions. Quick Quack Car Wash has the right, in its sole discretion, to maintain the integrity of the Campaign, to void entries for any reason, including, but not limited to: multiple entries from the same user from different IP addresses; multiple entries from the same computer in excess of that allowed by Campaign rules; or the use of bots, macros, scripts, or other technical means for entering. Any attempt by an entrant to deliberately damage any website or undermine the legitimate operation of the Campaign may be a violation of criminal and civil laws. Should such attempt be made, Quick Quack Car Wash reserves the right to seek damages to the fullest extent permitted by law.

Limitation of Liability: By entering, You agree to release and hold harmless Quick Quack Car Wash and its subsidiaries, affiliates, advertising and promotion agencies, partners, representatives, agents, successors, assigns, employees, officers, and directors from any liability, illness, injury, death, loss, litigation, claim, or damage that may occur, directly or indirectly, whether caused by negligence or not, from: (i) such entrant’s participation in the Campaign and/or his/her acceptance, possession, use, or misuse of any prize or any portion thereof; (ii) technical failures of any kind, including but not limited to the malfunction of any computer, cable, network, hardware, or software, or other mechanical equipment; (iii) the unavailability or inaccessibility of any transmissions, telephone, or Internet service; (iv) unauthorized human intervention in any part of the entry process or the Promotion; (v) electronic or human error in the administration of the Promotion or the processing of entries.

Disputes: THIS Campaign IS GOVERNED BY THE LAWS OF THE UNITED STATES, WITHOUT RESPECT TO CONFLICT OF LAW DOCTRINES. As a condition of participating in this Campaign, participant agrees that any and all disputes that cannot be resolved between the parties, and causes of action arising out of or connected with this Campaign, shall be resolved individually, without resort to any form of class action, exclusively before a court located in CA having jurisdiction. Further, in any such dispute, under no circumstances shall participant be permitted to obtain awards for, and hereby waives all rights to, punitive, incidental, or consequential damages, including reasonable attorney’s fees, other than participant’s actual out-of-pocket expenses (i.e. costs associated with entering this Campaign). Participant further waives all rights to have damages multiplied or increased.

Privacy Policy: Information submitted with an entry is subject to the Quick Quack Car Wash Privacy Policy.

Sponsor: The Sponsor of the Campaign is Quick Quack Car Wash, 297 E Hospitality Lane.

The Campaign hosted by Quick Quack Car Wash is in no way sponsored, endorsed, administered by, or associated with Facebook.`,
  freeDaysHeaderImg:
    "https://www.dontdrivedirty.com/wp-content/uploads/2025/02/68b89c6e-header-english_12yo0s8000000000000028.png.webp",
  freeDaysFeatherFormId: "zrN4e8",
  freeDaysTextBelowForm:
    "Celebrate the grand opening of our newest location in San Bernardino with 12 Days of FREE CAR WASHES! Come by our new location anytime from 4/30/25 – 5/11/25 to try our $27.99 Ceramic wash for free!",
  freeDaysUrl: "http://localhost:4200/grandopening/2601/freedays",
  freeDaysStartDate: "0001-01-01T00:00:00Z",
  freeDaysEndDate: "0001-01-01T00:00:00Z",
  storeHours: "Mon-Sun: 7am - 9pm",
  storeLat: 38.647611,
  storeLng: -121.23648,
  street: "1300 Prairie City Rd",
  city: "Folsom",
  state: "CA",
  zip: "95630",
  storeNumber: "2601",
};
